import React from 'react';
import { ManText } from '@craft-design-system/core-components-react';

const CustomTextDisplay = ({ value }) => {

  // 🔥 Convert anything to string safely
  let safeValue = '';

  if (typeof value === 'string') {
    safeValue = value;
  } else if (value === null || value === undefined) {
    safeValue = '';
  } else if (typeof value === 'object') {
    // If backend sends JSON/object → stringify it
    safeValue = JSON.stringify(value, null, 2);
  } else {
    safeValue = String(value);
  }

  // 🔥 Detect error responses safely
  const isErrorResponse =
    safeValue.includes('Failed to generate response') ||
    safeValue.includes('dependencyFailedException') ||
    safeValue.includes('failed response from API execution') ||
    safeValue.includes('Error: An error occurred') ||
    safeValue.startsWith('Error:');

  const displayValue = isErrorResponse
    ? 'Failed to generate response'
    : safeValue;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>

      {/* Title */}
      <div
        style={{
          position: 'relative',
          top: '18px',
          background: 'white',
          width: '270px',
          left: '3px'
        }}
      >
        <ManText
          className="daily-mileage-text"
          variant="component-l"
          as="span"
          size="xl"
          style={{
            textAlign: 'left',
            display: 'block',
            padding: '10px',
          }}
        >
          AI | Automotive Intelligence <span style={{ color: '#CBD3DC' }}>(BETA)</span>
        </ManText>
      </div>

      {/* Value box */}
      <div>
        <ManText
          className="daily-mileage-text"
          variant="body-m"
          as="span"
          size="xl"
          style={{
            border: '2px solid black',
            borderRadius: '8px',
            minHeight: '72px',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            textAlign: 'left',
            padding: '10px',
            overflow: 'hidden',
            wordWrap: 'break-word',
            whiteSpace: 'pre-wrap',
          }}
        >
          <span dangerouslySetInnerHTML={{ __html: displayValue }} />
        </ManText>
      </div>

    </div>
  );
};

export default CustomTextDisplay;
